import { ClientRequestItemStatus } from '@aiwyn/api';
import { BadgeColor } from '@aiwyn/shared';

export const ITEM_REQUEST_STATUS_LABEL: { [K in ClientRequestItemStatus]?: string } = {
  [ClientRequestItemStatus.OPEN]: 'Open',
  [ClientRequestItemStatus.IN_REVIEW]: 'In Review',
  [ClientRequestItemStatus.REJECTED]: 'Changes Requested',
  [ClientRequestItemStatus.DONE]: 'Accepted',
};

export const ITEM_REQUEST_STATUS_COLOR: { [K in ClientRequestItemStatus]?: BadgeColor } = {
  [ClientRequestItemStatus.OPEN]: 'blue',
  [ClientRequestItemStatus.IN_REVIEW]: 'yellow',
  [ClientRequestItemStatus.REJECTED]: 'red',
  [ClientRequestItemStatus.DONE]: 'green',
};
